import { LooseObject } from "./loose-object.model";
import { DisplayOption } from "./results/baseline/baseline-summary-display-option/baseline-summary-display-option.model";

export interface InputSummaryInterface {
  inputs: InputSummaryItem[];
  subSection: LooseObject;
}

export class InputSummary {
  inputs: InputSummaryItem[] = [];
  subSection = {};

  constructor() {
  }
}

export interface InputSummaryItemInterface {
  name: string | null;
  value: string | null;
  unit: string | null;
  path?: string[];
  id: string | null;
 'aux.DisplayOption'?: DisplayOption;
}

export class InputSummaryItem {
  name: string | null;
  value: string | null;
  unit: string | null;
  path?: string[];
  /**
   * this is used to build a unique id with translations ids
   * to allow for the inputs to be reselected when languages change
   */
  id: string | null;
 'aux.DisplayOption'?: DisplayOption;

  constructor(param: InputSummaryItemInterface = {
    name: null,
    value: null,
    unit: null,
    path: [],
    id: null
  }) {
    this.name = param.name;
    this.value = param.value;
    this.unit = param.unit;
    this.path = param.path;
    this.id = param.id;

    if (param['aux.DisplayOption']) {
      this['aux.DisplayOption'] = param['aux.DisplayOption']
    }
  }
}
